import instanceQuery from '../../../graphql/queries/bank/BankTransferPostingPreviewQuery.graphql';
import fragment from '../../../graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const BankTransferPostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default BankTransferPostingPreview;
